import { MapPin, Clock, Navigation, Users, Car } from "lucide-react";
import { Seo } from "../components/Seo";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { BUSINESS, restaurantLd, breadcrumbLd } from "../data/business";

export default function LokasiPage() {
  return (
    <>
      <Seo
        title="Lokasi Bakso Tujuh Pemuda — Alamat & Petunjuk Arah di Bogor"
        description="Alamat Bakso Tujuh Pemuda: Jl. Pengadilan No. 51, Pabaton, Bogor Tengah, Kota Bogor — seberang Sekolah Regina Pacis. Buka setiap hari 09.00–21.00 WIB."
        path="/lokasi/"
        jsonLd={[restaurantLd, breadcrumbLd([{ name: "Beranda", path: "/" }, { name: "Lokasi", path: "/lokasi/" }])]}
      />
      <PageHeader
        crumb="Lokasi"
        eyebrow="Bogor Tengah"
        lines={[<>Lokasi <span className="italic font-semibold text-terracotta">Bakso Tujuh Pemuda</span></>]}
      />
      <section className="py-16 sm:py-24" data-testid="lokasi-page">
        <div className="max-w-6xl mx-auto px-4 grid lg:grid-cols-2 gap-12">
          <div>
            <Reveal>
              <address className="not-italic" data-testid="lokasi-address-block">
                <h2 className="font-display font-black tracking-tight text-2xl sm:text-3xl flex items-center gap-3">
                  <MapPin className="text-terracotta shrink-0" size={26} /> Alamat
                </h2>
                <p className="mt-4 text-ink-soft leading-relaxed text-base sm:text-lg">
                  {BUSINESS.name}
                  <br />
                  {BUSINESS.address.full}
                </p>
                <p className="mt-3 inline-block rounded-full bg-tint border border-line px-4 py-2 text-sm font-semibold text-ink">
                  {BUSINESS.address.landmark}
                </p>
              </address>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-10 font-display font-black tracking-tight text-2xl sm:text-3xl flex items-center gap-3">
                <Clock className="text-terracotta shrink-0" size={26} /> Jam Buka
              </h2>
              <p className="mt-4 text-ink-soft text-base sm:text-lg" data-testid="lokasi-hours">{BUSINESS.hoursLabel}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <h2 className="mt-10 font-display font-black tracking-tight text-2xl sm:text-3xl flex items-center gap-3">
                <Users className="text-terracotta shrink-0" size={26} /> Fasilitas
              </h2>
              <ul className="mt-4 space-y-2.5 text-ink-soft">
                <li className="flex items-center gap-2.5"><Car size={16} className="text-amberbrand" /> Area parkir yang memadai</li>
                <li className="flex items-center gap-2.5"><Users size={16} className="text-amberbrand" /> Area makan luas, cocok untuk keluarga dan rombongan</li>
              </ul>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 flex flex-wrap gap-3">
                <a
                  href={BUSINESS.links.directions}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="google-maps-directions-button"
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-terracotta text-cream font-bold hover:bg-terracotta-dark transition-colors duration-300"
                >
                  <Navigation size={18} /> Petunjuk Arah
                </a>
                <a
                  href={BUSINESS.links.maps}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="lokasi-gmaps-link"
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-ink font-bold hover:bg-ink hover:text-cream transition-colors duration-300"
                >
                  Buka di Google Maps
                </a>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="rounded-[2.5rem] overflow-hidden border border-line shadow-xl lg:sticky lg:top-32">
              <iframe
                src={BUSINESS.links.mapsEmbed}
                title="Peta lokasi Bakso Tujuh Pemuda, Jl. Pengadilan No. 51, Bogor Tengah"
                width="600"
                height="560"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full"
                data-testid="lokasi-map-embed"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
